var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 46,
    viewBox: "0 0 10 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7402E",
    fillRule: "nonzero",
    d: "M9 0v17.722c0 1.88-.103 3.723-.309 5.53-.206 1.808-.48 3.724-.824 5.748H2.133c-.343-2.024-.618-3.94-.824-5.747A48.801 48.801 0 0 1 1 17.723V0h8zM0 41.515c0-.618.127-1.206.38-1.764a4.214 4.214 0 0 1 1.056-1.435 5.27 5.27 0 0 1 1.6-.957A5.423 5.423 0 0 1 5.016 37c.683 0 1.332.12 1.948.359.616.239 1.144.558 1.584.957.44.398.792.877 1.056 1.435S10 40.897 10 41.515c0 .638-.132 1.23-.396 1.779a4.574 4.574 0 0 1-1.056 1.42c-.44.399-.968.713-1.584.942A5.538 5.538 0 0 1 5.017 46a5.632 5.632 0 0 1-1.98-.344 5.046 5.046 0 0 1-1.601-.942 4.255 4.255 0 0 1-1.056-1.42A4.193 4.193 0 0 1 0 41.515z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.3aec29b3.svg";
export { ForwardRef as ReactComponent };